var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",class:_vm.size,style:(_vm.image ? `background-image: url(${_vm.image}); background-color: unset !important;` : '')},[(!_vm.image)?[_vm._v(_vm._s(_vm._f("initials")(_vm.name,1)))]:_vm._e(),(_vm.showAvailabilityStatus)?_c('span',{staticClass:"indicator",class:[_vm.available ? 'green' : 'red']}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }